var map = {
	"./Pusat Penelitian Data dan Informasi_page-0002.jpg": 74343,
	"./Pusat Penelitian Data dan Informasi_page-0003.jpg": 40987,
	"./Pusat Penelitian Data dan Informasi_page-0004.jpg": 91972,
	"./Pusat Penelitian Data dan Informasi_page-0005.jpg": 67850,
	"./Pusat Penelitian Data dan Informasi_page-0006.jpg": 88299,
	"./Pusat Penelitian Data dan Informasi_page-0007.jpg": 68554,
	"./Pusat Penelitian Data dan Informasi_page-0008.jpg": 70407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 51726;